export const WITH_LINK_SANITIZE_CONFIG = {
  ADD_ATTR: ['target', 'href'],
};
